export default "__VITE_ASSET__6UkugnZs__"